/// <amd-module name="VSSUI/ZeroData" />
export * from "./Components/ZeroData/index";
